import axios from 'axios';
import { clearAuthData } from './lineService';

// Base API Configuration
// Use proxy in development to avoid CORS
// NOTE: MemberLabList.php ใช้ v1.0.0, endpoints อื่นใช้ oav1.0.0
const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? '/api'
  : 'https://server.dietz.asia/openApi/mfu/oav1.0.0';
const API_AUTH_TOKEN = 'DDQ8y7V19LaWvI*j';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': API_AUTH_TOKEN
  },
  timeout: 30000 // 30 seconds timeout
});

// Request interceptor - add token if available
apiClient.interceptors.request.use(
  (config) => {
    // MemberLabList.php ต้องใช้ v1.0.0 แทน oav1.0.0
    if (config.url?.includes('MemberLabList.php')) {
      config.baseURL = process.env.NODE_ENV === 'development'
        ? '/api'
        : 'https://server.dietz.asia/openApi/mfu/v1.0.0';
    }

    // Don't add token for Register and Login endpoints
    const isRegisterOrLogin = config.url?.includes('Register.php') || config.url?.includes('Login.php');

    // Debug: log request data
    console.log('🚀 API Request:', config.url, 'Data:', config.data);

    if (!isRegisterOrLogin) {
      // ลองดึง token จากทั้งสอง key (เพื่อความเข้ากันได้)
      const token = localStorage.getItem('token') || localStorage.getItem('userToken') || localStorage.getItem('preAuthToken');
      if (token) {
        config.data = {
          ...config.data,
          token: token
        };
        console.log('🔑 Added token to request');
      } else {
        console.warn('⚠️ No token found in localStorage');
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle common errors
apiClient.interceptors.response.use(
  (response) => {
    // Return the full response data
    // API returns data directly without wrapper
    return response.data;
  },
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error('API Error:', error.response.data);

      // Handle specific status codes
      if (error.response.status === 401) {
        // Unauthorized - แต่ไม่ clear session ยกเว้น token expired จริงๆ
        const message = error.response.data?.message?.toLowerCase() || '';
        const responseText = error.response.data?.responseText?.toLowerCase() || '';

        // เช็คว่าเป็น token expired จริงๆ (ไม่ใช่แค่ OTP ผิดหรือยังไม่ได้ login)
        const isTokenExpired = (message.includes('token') && (message.includes('expired') || message.includes('invalid'))) ||
                               (responseText.includes('token') && (responseText.includes('expired') || responseText.includes('invalid')));

        if (isTokenExpired) {
          console.warn('⚠️ Token expired or invalid, clearing session');
          clearAuthData();
          window.location.href = '/login';
        } else {
          // ถ้าไม่ใช่ token expired ก็แค่ throw error ไป ไม่ต้อง clear session
          console.log('ℹ️ 401 error but not token expiration:', message || responseText);
        }
      }
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.request);
    } else {
      // Something else happened
      console.error('Error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
